<template>
  <div class="app-settings">
    <h3>系统设置</h3>
    
    <el-tabs v-model="activeTab">
      <el-tab-pane label="个人信息" name="profile">
        <el-form :model="profile" label-width="100px" style="max-width: 500px;">
          <el-form-item label="用户名">
            <el-input v-model="profile.username" disabled></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="profile.name"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="profile.email"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="profile.phone"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveProfile">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      
      <el-tab-pane label="修改密码" name="password">
        <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px" style="max-width: 500px;">
          <el-form-item label="当前密码" prop="oldPassword">
            <el-input v-model="passwordForm.oldPassword" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input v-model="passwordForm.newPassword" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input v-model="passwordForm.confirmPassword" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="changePassword">修改密码</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      
      <el-tab-pane label="通知设置" name="notification">
        <el-form label-width="150px" style="max-width: 500px;">
          <el-form-item label="邮件通知">
            <el-switch v-model="notification.email"></el-switch>
          </el-form-item>
          <el-form-item label="短信通知">
            <el-switch v-model="notification.sms"></el-switch>
          </el-form-item>
          <el-form-item label="问卷提交通知">
            <el-switch v-model="notification.formSubmit"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveNotification">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'AppSettings',
  
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }
    
    return {
      activeTab: 'profile',
      profile: {
        username: '',
        name: '',
        email: '',
        phone: ''
      },
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [{ required: true, message: '请输入当前密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      notification: {
        email: true,
        sms: false,
        formSubmit: true
      }
    }
  },
  
  computed: {
    userInfo() {
      return this.$store.getters.userInfo || {}
    }
  },
  
  mounted() {
    this.profile = {
      username: this.userInfo.username || '',
      name: this.userInfo.name || '',
      email: this.userInfo.email || '',
      phone: this.userInfo.phone || ''
    }
  },
  
  methods: {
    saveProfile() {
      // TODO: 调用保存个人信息API
      this.$message.success('保存成功')
    },
    
    async changePassword() {
      try {
        await this.$refs.passwordForm.validate()
        // TODO: 调用修改密码API
        this.$message.success('密码修改成功，请重新登录')
        // 退出登录
        localStorage.removeItem('ACCESS_TOKEN')
        window.location.href = '/login'
      } catch (e) {
        // 验证失败
      }
    },
    
    saveNotification() {
      // TODO: 调用保存通知设置API
      this.$message.success('保存成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.app-settings {
  padding: 0;
  
  h3 {
    margin: 0 0 24px;
    font-size: 18px;
    font-weight: 500;
  }
}
</style>
